import type { UpdateOneShopReturnToStoreStoreDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

type UseUpdateShopStoreParams = {
  shopId: string;
  storeId: string;
  onSettled?: (
    data: unknown,
    error: unknown,
    variables: unknown,
    context?: unknown,
  ) => Promise<unknown> | unknown;
};

/**
 * Types are not done on the API
 */
// function oldUpdate(shop: ShopDto, storeId: string, store: any) {
//   return Meteor.callAsync("updateStore", {
//     shopId: shop.id,
//     storeId,
//     store
//   });
// }

export default function useUpdateShopStore({
  shopId,
  storeId,
  onSettled,
}: UseUpdateShopStoreParams) {
  const invalidateShop = useInvalidateShop(shopId);

  return useApiMutation("patch", "/shops/{shopId}/return-to-store/stores/{storeId}", {
    invalidate: invalidateShop,
    onSettled,
    mapVariables: (requestBody: UpdateOneShopReturnToStoreStoreDto) => ({
      params: { path: { shopId, storeId } },
      body: requestBody,
    }),
  });
}
